import { useAuth } from '@/contexts/Auth'

const TRAINER_STAFF_ROLE_CODE = 'trainer-staff'
const AQUATIC_STAFF_ROLE_CODE = 'aquatic-staff'

/**
 * QTY-1916..1920: floor-level staff (trainer-staff / aquatic-staff) get a
 * restricted CRM view — their own PT / Swimming Coach detail ("My Clients &
 * Schedule"), shared goal settings, and view-only Member Detail reached from
 * their own Client List. This hook centralises the role detection plus the
 * paths the restricted menu entries point at.
 */
export const useRestrictedStaff = () => {
  const { roleAndPermissions, profile } = useAuth()
  const roleCode = roleAndPermissions?.code

  const isTrainerStaff = roleCode === TRAINER_STAFF_ROLE_CODE
  const isAquaticStaff = roleCode === AQUATIC_STAFF_ROLE_CODE
  const staffId = profile?.id

  return {
    isTrainerStaff,
    isAquaticStaff,
    isRestrictedStaff: isTrainerStaff || isAquaticStaff,
    /** Logged-in staff user id — the only trainer/coach detail they may open. */
    staffId,
    /** Own PT detail path (trainer-staff) — undefined until the profile loads. */
    myPtDetailPath: staffId != null ? `/personal-trainer/${staffId}` : undefined,
    /** Own Swimming Coach detail path (aquatic-staff). */
    myCoachDetailPath: staffId != null ? `/swimming-coach/${staffId}/details` : undefined,
  }
}
